// Angular Core
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  OnDestroy,
} from '@angular/core';
// Store
import { select, Store } from '@ngrx/store';
// Store - Reducer
import { AppState } from '@app/general/store/reducers';
import { ModuleState } from '@accounts/store/reducers';
// Store - Actions
import * as AuthActions from '@app/general/store/actions/auth.actions';
// Store - Selectors
import * as AuthSelectors from '@store/selectors/auth.selectors';
// Rxjs
import { fromEvent, Subscription } from 'rxjs';
// PrimeNG API
import { LazyLoadEvent } from 'primeng/api';
import { Table } from 'primeng/table';
// Libreria
import { cloneDeep } from 'lodash';
import { Paginator } from 'primeng/paginator';

@Component({
  selector: 'sbi-cot-back-dynamic-check-list',
  templateUrl: './dynamic-check-list.component.html',
  styleUrls: ['./dynamic-check-list.component.scss'],
  standalone: false,
})
export class DynamicCheckListComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @ViewChild('paginator', { static: true }) paginator: Paginator;
  @ViewChild('pTable', { static: true }) table: Table;

  // Inputs Table
  @Input() hasConfigurationTableButton = true;
  @Input() configListado: string = '';
  @Input() sortAndFilteringCFG: any;
  @Input() saveFilterAndSorting: string = '';
  @Input() noResultsMessage: string = 'No se encontraron resultados.';
  @Input() set listColumns(val: any[]) {
    this.internalListColumns = cloneDeep(val);

    this._fetchAccountListColumnsOrder();
  }

  @Input() set list(val: any[]) {
    this._internalList = val;
    this.internalCheckList = this._internalList.map(row => {
      return (row = { ...row, checked: false });
    });
    if (!this.allRowsCheckList || this.allRowsCheckList.length === 0)
      this.allRowsCheckList = cloneDeep(this.internalCheckList);

    this.fillCheckList();
  }
  @Input() hasCheckBoxList: boolean = false;
  @Input() hasClearButton: boolean = true;

  @Input() noCurrency: boolean = false;

  @Input() loading: boolean = false;
  @Input() loadingFormData: boolean = false;

  @Input() data: any;

  @Input() rows: number;
  @Input() totalTableItems: number = 0;
  @Input() actualPage: number = 0;
  @Input() rowsPerPageOptions: number[];
  @Input() showPaginator: boolean = false;

  @Output() clearFilters = new EventEmitter();
  @Output() tableDataChange = new EventEmitter();
  @Output() saveFilteringAndSortingConfiguration = new EventEmitter();
  @Output() rowClicked = new EventEmitter();
  @Output() checkListModified = new EventEmitter();
  @Output() paginateEvent = new EventEmitter();

  _internalFiltersSaved = null;
  internalListColumns = null;
  _internalList = null;
  public allRowsCheckList = null;
  public internalCheckList = null;

  //------ Public variables ------//

  // Button table config
  // Button table config
  public listConfigColumns = null;
  public showActionHeader = false;
  public hasFetchedData = false;

  // Store Selectors
  public _getConfigListadoRequested$ = this._storeApp$.pipe(
    select(AuthSelectors.getConfigListadoRequested)
  );
  public _getConfigListadoResponse$ = this._storeApp$.pipe(
    select(AuthSelectors.getConfigListadoResponse)
  );
  public _setConfigListadoRequested$ = this._storeApp$.pipe(
    select(AuthSelectors.setConfigListadoRequested)
  );
  private _subscriptions$: Subscription[] = [];
  private _columnsSaved = [];
  private = [];
  public columnActionField = 'actions';

  public checkAll: boolean = false;

  // Constructor
  constructor(
    private _store$: Store<ModuleState>,
    private _storeApp$: Store<AppState>,
    private elementRef: ElementRef,
    private _cdRef: ChangeDetectorRef
  ) {}

  // On component init
  ngOnInit() {
    // Default sort order
    this._setTableColumns();

    this.table.sortField =
      this.sortAndFilteringCFG?.sortField || this.data?.sortField;
    this.table.sortOrder =
      this.sortAndFilteringCFG?.sortOrder || this.data?.sortOrder;
    if (this.sortAndFilteringCFG?.filters) {
      this.table.filters = this.sortAndFilteringCFG?.filters;
    }

    const tabla = document.querySelector('#tabla');
    if (!!tabla) {
      fromEvent(tabla, 'click').subscribe(event => {
        const policyNumber = (event.target as Element).getAttribute(
          'policynumber'
        );
        if (policyNumber) {
          this.rowClicked.emit(policyNumber);
        }
      });
    }

    this._setConfigListadoRequested();
  }

  change;
  ngAfterViewInit() {
    this.change = true;
    if (this.data) {
      this.paginator._first = this.data.first;
      this.table.sortField = this.data.sortField;
      this.table.sortOrder = this.data.sortOrder;
      this.table.filters = this.data.filters;
    }
    this.table.sortField = this.sortAndFilteringCFG?.sortField || '';
    this.table.sortOrder = this.sortAndFilteringCFG?.sortOrder || null;
    if (this.sortAndFilteringCFG?.filters) {
      this.table.filters = this.sortAndFilteringCFG?.filters;
    }
    if (this.sortAndFilteringCFG?.page !== 0)
      this.paginator.changePage(this.sortAndFilteringCFG?.page);
  }

  // On component destroy
  ngOnDestroy() {
    this._subscriptions$.forEach(sub => sub.unsubscribe());
    this.elementRef.nativeElement.remove();
  }

  public onTableDataChange(filterAndOrderCriteria: LazyLoadEvent): void {
    this.loading = true;
    this.tableDataChange.emit(filterAndOrderCriteria);
    this.paginator.changePage(0);
  }

  onChangeConfig(listColumns: any[]) {
    for (let i = 0; i < this.listConfigColumns.length; i++) {
      this.listConfigColumns[i].visible = !!listColumns.find(
        x => x.header === this.listConfigColumns[i].header /*&& x.visible*/
      );
    }
    for (let i = 0; i < this.internalListColumns.length; i++) {
      this.internalListColumns[i].visible = !!this.listConfigColumns.find(
        x => x.header === this.internalListColumns[i].header && x.visible
      );
    }
  }

  onSaveConfig() {
    this._setConfigListado(this.internalListColumns);
  }

  private _setConfigListado(columns, filters = null) {
    let key = this.configListado;
    let config = null;
    if (columns) {
      this._columnsSaved = columns.map(element => {
        return { field: element.field, visible: element.visible };
      });
      config = this._columnsSaved;
    } else {
      key += '.Filters';
      config = filters;
    }

    this._store$.dispatch(
      AuthActions.setConfigListadoRequested({
        payload: {
          key,
          config,
        },
      })
    );
  }

  private _setConfigListadoRequested() {
    this._subscriptions$.push(
      this._setConfigListadoRequested$.subscribe(config => {
        if (config != undefined) {
          this.loading = config;
        }
      })
    );
  }

  private fillCheckList() {
    this.internalCheckList.forEach(row => {
      const keys = Object.keys(row);
      this.allRowsCheckList.forEach(alreadyRow => {
        let isTheSameRow = true;
        for (const key of keys) {
          if (row[key] !== alreadyRow[key] && key !== 'checked') {
            isTheSameRow = false;
          }
        }
        if (isTheSameRow) {
          row.checked = alreadyRow.checked;
          return;
        }
      });
    });
  }

  private _fetchAccountListColumnsOrder() {
    this._store$.dispatch(
      AuthActions.getConfigListadoRequested({
        payload: { key: this.configListado },
      })
    );
  }

  private _fillList() {
    this.listConfigColumns = [];
    for (let i = 0; i < this.internalListColumns.length; i++) {
      if (!this.internalListColumns[i].config) {
        this.showActionHeader = true;
        continue;
      }
      this.listConfigColumns.push(this.internalListColumns[i]);
      if (this.internalListColumns.length - 1 == i) {
        this.loading = false;
      }
    }
  }

  // Set table columns
  private _setTableColumns(): void {
    this._getConfigListadoResponse$.subscribe(res => {
      if (res && !res.invalid && res.key === this.configListado && res.config) {
        const columnsSaved = res.config;
        const columns = [];
        columnsSaved.forEach(element => {
          const column = this.internalListColumns.find(
            col => col.field === element.field
          );
          if (column) {
            column.visible = element.visible;
            columns.push(column);
          }
        });
        this.internalListColumns
          .filter(element => !columns.find(col => col.field === element.field))
          .forEach(element => {
            element.visible = element.config;
            columns.push(element);
          });

        this.internalListColumns = [];
        for (let i = 0; i < columns.length; i++) {
          if (!columns[i].frozen) {
            this.internalListColumns.push(columns[i]);
          }
        }
        for (let i = 0; i < columns.length; i++) {
          if (columns[i].frozen && columns[i].alignFrozen === 'right') {
            this.internalListColumns.push(columns[i]);
          }
          if (columns[i].frozen && columns[i].alignFrozen === 'left') {
            this.internalListColumns.splice(0, 0, columns[i]);
          }
        }
      }
      this._fillList();
    });
  }

  onClearFilters() {
    this.clearFilters.emit();
    this.table.clear();
    this.paginator.changePage(0);
  }

  getColumns() {
    // Devuelve los headers ?
    if (!this.internalListColumns || !this.listConfigColumns) return [];
    return this.internalListColumns.filter(x => {
      return (
        !x.config ||
        this.listConfigColumns.find(y => y.header === x.header && y.visible)
      );
    });
  }

  onInputDate(value, id) {
    if (value != null) this.table.filters[id][0].value = value;
  }

  toggleFilterCheckAll(value: boolean) {
    this.checkAll = value;
    this.internalCheckList.forEach((rowIL, index) => {
      rowIL.checked = this.checkAll;
      this.allRowsCheckList.forEach(row => {
        this._checkGlobalList(index, row);
      });
    });
    // Outside output must be any
    this.checkListModified.emit({
      checked: this.internalCheckList.filter(row => row.checked),
      allChecked: this.allRowsCheckList.filter(row => row.checked),
    });
  }

  toggleRowFilterCheck(index: number) {
    this.internalCheckList[index].checked = (<HTMLInputElement>(
      document.getElementById(index + '')
    )).checked;
    this.allRowsCheckList.forEach(row => {
      this._checkGlobalList(index, row);
    });
    // Outside output must be any
    this.checkListModified.emit({
      checked: this.internalCheckList.filter(row => row.checked),
      allChecked: this.allRowsCheckList.filter(row => row.checked),
    });
  }

  uncheckAll() {
    this.allRowsCheckList.forEach(row => {
      row.checked = false;
    });
    this.checkAll = false;
  }

  private _checkGlobalList(index: number, row) {
    const keys = Object.keys(this.internalCheckList[index]);
    let isTheSameRow = true;
    for (const key of keys) {
      if (
        row[key] !== this.internalCheckList[index][key] &&
        key !== 'checked'
      ) {
        isTheSameRow = false;
      }
    }
    if (isTheSameRow) {
      row.checked = this.internalCheckList[index].checked;
      return;
    }
  }

  paginate(event: any) {
    this.paginateEvent.emit(event);
  }

  countTitle() {
    if (this.paginator?.totalRecords === undefined) {
      return 0;
    }

    let first = this.paginator.totalRecords == 0 ? 0 : this.paginator.first + 1;
    const totalRecords = this.paginator.totalRecords;
    let last = this.paginator.first + this.paginator.rows;
    if (last > totalRecords) last = totalRecords;
    if (first > last) first = 1;
    return `${first}-${last} de ${totalRecords} resultados`;
  }
}
